import React from "react";
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import {
  LocalizeContextProps,
  Translate as T,
  withLocalize,
} from "react-localize-redux";
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import esFlag from "../../../../assets/logos/emojione_flag-for-spain.svg";
import enFlag from "../../../../assets/logos/emojione_flag-for-united-states.svg";
import brFlag from "../../../../assets/logos/emojione_flag-for-brazil.svg";
import InputBase from "@material-ui/core/InputBase";
import { ArrowDropDown } from "@material-ui/icons";

const Input = withStyles((theme: Theme) =>
  createStyles({
    input: {
      "& .MuiSelect-outlined": {
        paddingRight: "0px",
      },
      alignItems: "center",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid white",
      borderRadius: 6,
      fontSize: 14,
      padding: "7px 0px 5px 7px",
      position: "relative",
    },
  })
)(InputBase);

const useStyles = makeStyles((theme) => ({
  boxIcon: {
    alignItems: "center",
    borderLeft: "1px solid LightGrey",
    display: "flex",
    height: "24px",
    pointerEvents: "none",
    position: "absolute",
    right: "0",
    width: "24px",
  },
  formControl: {
    "& .MuiInputBase-root": {
      height: 36,
    },
    "& .MuiSelect-select.MuiSelect-select": {
      paddingLeft: 16,
      paddingRight: 36,
    },
    backgroundColor: "white",
    borderRadius: 6,
    fontSize: "14px",
    outlineColor: "#FFFFFF",
    paddingRight: "0px",
  },
  img: {
    marginRight: theme.spacing(2),
    verticalAlign: "middle",
  },
  label: {
    color: "#023365",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "140%",
    paddingRight: 0,
  },
  language: {
    paddingRight: "5px",
  },
  select: {
    "& .MuiSelect-outlined": {
      paddingRight: "26px",
    },
    borderRadius: 5,
    color: "#023365",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "140%",
    paddingRight: 0,
  },
}));

export type TSelectLanguageProps = LocalizeContextProps;
export const SelectLanguage = (props: TSelectLanguageProps) => {
  const classes = useStyles();

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <Box>
        <Select
          id="languages"
          value={props.activeLanguage?.code || "es"}
          className={classes.label}
          input={<Input />}
          IconComponent={() => (
            <Box className={classes.boxIcon}>
              <ArrowDropDown />
            </Box>
          )}
        >
          <MenuItem
            id="es"
            value="es"
            onClick={() => props.setActiveLanguage("es")}
          >
            <Box display={"flex"}>
              <Typography className={classes.label}>
                <T id="languages.es" />
              </Typography>
              <Box display={"flex"} ml={1}>
                <img src={esFlag} className={classes.language} alt={esFlag} />
              </Box>
            </Box>
          </MenuItem>

          <MenuItem
            id="en"
            value="en"
            onClick={() => props.setActiveLanguage("en")}
          >
            <Box display={"flex"}>
              <Typography className={classes.label}>
                <T id="languages.en" />
              </Typography>
              <Box display={"flex"} ml={1}>
                <img src={enFlag} className={classes.language} alt={enFlag} />
              </Box>
            </Box>
          </MenuItem>

          <MenuItem
            id="br"
            value="br"
            onClick={() => props.setActiveLanguage("br")}
          >
            <Box display={"flex"}>
              <Typography className={classes.label}>
                <T id="languages.br" />
              </Typography>
              <Box display={"flex"} ml={1}>
                <img src={brFlag} className={classes.language} alt={brFlag} />
              </Box>
            </Box>
          </MenuItem>
        </Select>
      </Box>
    </FormControl>
  );
};
export default withLocalize<LocalizeContextProps>(SelectLanguage);
